__turbopack_context__.v({
  "container": "GiftTrackingMessage-module__Sn3Tja__container",
  "containerLandscape": "GiftTrackingMessage-module__Sn3Tja__containerLandscape" + " " + "GiftTrackingMessage-module__Sn3Tja__container",
  "containerPortrait": "GiftTrackingMessage-module__Sn3Tja__containerPortrait" + " " + "GiftTrackingMessage-module__Sn3Tja__container",
});
